import React, { useState } from "react";
import { FC } from "react";
import { Button, Edit, EditProps, SelectInput, TextInput, Toolbar, useNotify } from "react-admin";
import { useAppDataProvider } from "../../../../src/dataprovider";
import { useHistory } from "react-router-dom";
import { CircularProgress, Grid, makeStyles } from "@material-ui/core";
import { NffReportExclusionPnPutModel } from "./Model/NffReportExclusionPnModel";
import { Form } from "react-final-form";
import { Separator } from "../../../../src/Components/Separator";
import { SectionTitle } from "../../../../src/Components/SectionTitle";
import { Update } from "@material-ui/icons";
import { ThyFleetTypes } from "../../../../src/Constants/Constant";

const gridContainerProps: any = {
  container: true,
  direction: "row",
  item: true,
  xs: 12,
  spacing: 1,
  justify: "space-around",
  alignItems: "center",
};

const NffReportExclusionPnEditComponent = props => {
  const dataProvider = useAppDataProvider();
  const notify = useNotify();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [customerCodeList, setCustomerCodeList] = useState<any>([]);

  const useStyles = makeStyles({
    toolbar: {
      display: "flex",
      justifyContent: "end",
      backgroundColor: "white",
    },
    defaultToolbar: {
      display: "flex",
      justifyContent: "end",
    },
  });
  const classes = useStyles();

  const GetCustomerCodeList = () => {
    dataProvider
      .getList("customers", {
        pagination: { page: 1, perPage: 1000 },
        sort: { field: "customerName", order: "ASC" },
        filter: {},
      })
      .then(response => {
        // Create a map to deduplicate by customerCode
        const customerMap = new Map();

        response?.data?.forEach(item => {
          if (!customerMap.has(item.customerCode)) {
            customerMap.set(item.customerCode, {
              customerCode: item.customerCode,
              customerName: item.customerCode,
            });
          }
        });

        // Convert map to array and add THY-C at the beginning
        const customerCodes = Array.from(customerMap.values());
        setCustomerCodeList(customerCodes);
      })
      .catch(error => {
        console.log(error);
      });
  };

  React.useEffect(() => {
    GetCustomerCodeList();
  }, []);

  const EditNffReportExclusionPnButtonClick = e => {
    EditNffReportExclusionPn(e);
  };

  const EditNffReportExclusionPn = async e => {
    let editModel: NffReportExclusionPnPutModel = new NffReportExclusionPnPutModel();

    editModel.Id = props.id;
    editModel.Pn = e.pn;
    editModel.Customer = e.customer ?? "";
    editModel.FleetType = e.fleetType ?? "";

    dataProvider
      .putNffReportExclusionPn(editModel)
      .then(result => {
        notify(`Record updated`, "success", false, true);
        history.push("/reliabilitynffexclusionpns");
      })
      .catch(result => notify(`${result}`, "error", false, true))
      .finally(() => setLoading(false));
  };

  return (
    <Form
      onSubmit={EditNffReportExclusionPnButtonClick}
      render={({ handleSubmit }) => (
        <form>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
              <Edit {...props}>
                <>
                  <Separator />
                  <Grid {...gridContainerProps}>
                    <SectionTitle label="NFF Report Exclusion PN" />
                  </Grid>
                  <Separator />

                  <Grid {...gridContainerProps}>
                    <Grid item xs={12} sm={5}>
                      <TextInput source="pn" label="Pn" fullWidth disabled variant="outlined" />
                    </Grid>

                    <Grid item xs={12} sm={5}>
                      <SelectInput
                        source="customer"
                        optionValue="customerCode"
                        optionText="customerName"
                        fullWidth
                        variant="outlined"
                        choices={customerCodeList}
                        label="Customer"
                        allowEmpty
                      />
                      <SelectInput
                        source="fleetType"
                        optionValue="value"
                        optionText="type"
                        fullWidth
                        variant="outlined"
                        choices={ThyFleetTypes}
                        label="Fleet Type"
                        allowEmpty
                      />
                    </Grid>
                  </Grid>

                  <Separator />
                  <Toolbar {...props} placeholder="" classes={classes}>
                    <Button
                      label={loading ? "Exclusion PN is updating!" : "Update Exclusion PN"}
                      disabled={loading}
                      size="medium"
                      variant="contained"
                      color="primary"
                      onClick={handleSubmit}
                    >
                      {loading ? <CircularProgress size="2rem" color="secondary" /> : <Update />}
                    </Button>
                  </Toolbar>
                </>
              </Edit>
            </Grid>
          </Grid>
        </form>
      )}
    />
  );
};

const NffReportExclusionPnEdit: FC<EditProps> = props => {
  return (
    <Edit {...props} title={"NFF Report Exclusion PN Edit"} component="div" hasShow={false}>
      <NffReportExclusionPnEditComponent {...props} />
    </Edit>
  );
};

export default NffReportExclusionPnEdit;
